module.exports = __webpack_public_path__ + "img/homework-empty@2x.8a416349.png";